import { ReactComponent as IconNoMessage } from '@/assets/svgs/icon-ds-info.svg';
import Tooltip from "@/componentsDS/Tooltip/index";
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { ToggleSwitch } from "@/components/ToggleSwitch2/index";
import Tabs, { Tab } from '@/components/Tabs/index'
import PropTypes from 'prop-types';
import Loader from '@/componentsDS/Loader/Loader';

export const NoMessage = () => {
    return (
        <div className="data-table__empty__icon">
            <IconNoMessage />
            <span>You have no unread notifications.</span>
        </div>
    )
}

const NotificationPage = forwardRef(({
    notificationType,
    pivotNotification,
    notificationArr,
    onlyUnRead,
    getAllNotifications,
    markReadNotificationItem,
    markReadAllNotifications,
    showUnreadNotifications,
    initNotifications,
    handleRedirect,
    setIsActive,
    loading
}, ref) => {


    useImperativeHandle(ref, () => ({
        handleNotificationListScroll,
    }))

    const [toggleChecked, setToggleChecked] = useState({
        checked: onlyUnRead,
    });

    useEffect(() => {
        setToggleChecked({ checked: onlyUnRead });
    }, [onlyUnRead])

	let locker = false;

    async function handleNotificationListScroll(e, isWholeScreenScroll=false) {
		if (locker) {
			return;
		}
		if (isWholeScreenScroll) {
			if ((document.documentElement.scrollHeight - window.scrollY - window.innerHeight) <= 1) {
				locker = true;
				await getAllNotifications(pivotNotification);
				locker = false;
			}
			return;
		}
        const target = e.target;
        if ((target.scrollHeight - target.scrollTop - target.clientHeight) <= 1) {
			locker = true;
            await getAllNotifications(pivotNotification);
			locker = false;
        }
    }

    useEffect(async () => {
		const limit = notificationType === "page" ? 32 : 8;
        await initNotifications(limit);
    }, [])

    // Default Notification Section Tabs
    const defaultTabItems = [
        {
            label: "All",
            active: true,
            id: "All"
        }
    ]
    const [tabsItems] = useState(
        [defaultTabItems[0]].map((item) => ({
            ...item,
            active: true,
        }))
    )

    // Notification Listing
    const list = notificationArr?.map((item, index) => {
        return (
            <div className={notificationType === "page" ? "notification-page__listing" : "notification-page__listing-in-app"} key={item.notificationId} role='none' onClick={() => {
                handleRedirect(item.relativePath, item.notificationId)
                setIsActive(false)
            }}>
                <div className={notificationType === "page" ? "notification-page__listing-message" : "notification-page__listing-message__inapp"}>
                    <div dangerouslySetInnerHTML={{ __html: item.message }}></div>
                </div>
                {notificationType === "page" ? <div className='notification-page__listing-right'>
                    {item.read === false && <Tooltip id={`notification_tooltip_id_${index + 1}`} content={"Mark as read"}>
                        <div className='notification-page__listing-unread' role='none' onClick={(e) => { markReadNotificationItem(e, item.notificationId) }}>
                            <div className="notification-page__listing-icon"></div>
                        </div>
                    </Tooltip>}
                    <div className="notification-page__listing-date">
                        {item.date}
                    </div>
                </div> : <div className='notification-page__listing-right__inapp'>
                    <div>
                        {item.date}
                    </div>
                    <div className="notification-page__listing-right__inapp-icon">
                        {item.read === false && <Tooltip id={`notification_tooltip_id_${index + 1}`} content={"Mark as read"}>
                            <div className='notification-page__listing-unread' onClick={(e) => { markReadNotificationItem(e, item.notificationId) }} role='none'>
                                <div className="notification-page__listing-icon"></div>
                            </div>
                        </Tooltip>}
                    </div>
                </div>}
            </div>
        )
    })

    return (
        <>
            <div className='notification-sticky-header'>
                <div className="title-header">
                    <div className="title-header__left">
                        <div className={notificationType === "in-app" ?"title-header__title_notification-in-app":"title-header__title_notification"}>{"Notifications"}</div>
                    </div>
                    <div className="title-header__right">
                        {<div className='notification-main-header__action'>
                            {notificationType === "in-app" && <><span className='notification-main-header__action-unread' >Only show unread</span>
                                <ToggleSwitch item={toggleChecked} callback={() => showUnreadNotifications()} /></>}
                        </div>}
                    </div>
                </div>
                {/* Notification Heading */}
                {/* <Tabs>
                    {tabsItems.map((item, index) => (
                        <Tab key={item.id} id={item.id} label={item.label} active={item.active} />
                    ))}
                </Tabs> */}
                <div className='notification-main-header'>
                    <div className='notification-main-header__title'>Latest</div>
                    {<div className='notification-main-header__action'>
                        <span className='notification-main-header__action-read' onClick={() => markReadAllNotifications()} role='none'>Mark all as read</span>
                        {notificationType === "page" && <><span className='notification-main-header__action-unread'>Only show unread</span>
                            <ToggleSwitch item={toggleChecked} callback={() => showUnreadNotifications()} /></>}
                    </div>}
                </div>
            </div>

            {/* Notification listing */}
            <div className={notificationType === "page" ? "notification-list" : "notification-list-inapp"}>
                {notificationArr?.length > 0 ?
                    list :
                    !loading && <div className="notification-list-table__empty"><NoMessage /></div>
                }
                {loading && <div className='notification-list__loader-icon'><Loader /></div>}
            </div>
        </>
    )
})

export default NotificationPage


NotificationPage.propTypes = {
    notificationType: PropTypes.oneOf(['page', 'in-app']).isRequired,
    pivotNotification: PropTypes.string,
    notificationArr: PropTypes.arrayOf(
        PropTypes.shape({
            notificationId: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
            read: PropTypes.bool.isRequired,
            date: PropTypes.string.isRequired,
            relativePath: PropTypes.string.isRequired,
        })
    ).isRequired,
    onlyUnRead: PropTypes.bool,
    getAllNotifications: PropTypes.func.isRequired,
    markReadNotificationItem: PropTypes.func.isRequired,
    markReadAllNotifications: PropTypes.func.isRequired,
    showUnreadNotifications: PropTypes.func.isRequired,
    initNotifications: PropTypes.func.isRequired,
    handleRedirect: PropTypes.func.isRequired,
    setIsActive: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
};
